import React from 'react'

const Card = ({ title,
    subtitle,
    children,
    className = '',
    headerAction,
    noPadding = false, }) => {
    return (
        <div className={`bg-transparent rounded-lg shadow-card border border-zinc-500 ${className} overflow-hidden`}>
            {(title || subtitle) && (
                <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
                    <div>
                        {title && <h3 className="text-lg font-semibold text-neutral-900">{title}</h3>}
                        {subtitle && <p className="text-sm text-neutral-500 mt-0.5">{subtitle}</p>}
                    </div>
                    {headerAction && <div>{headerAction}</div>}
                </div>
            )}
            <div className={noPadding ? '' : 'p-6'}>{children}</div>
        </div>
    )
}

export default Card